import { useSelector } from 'react-redux';
import { selectIsFeatureEnabled } from 'tradera/state/environment/selectors';

export const useIsFeatureEnabled = (featureName: string) =>
    useSelector(selectIsFeatureEnabled(featureName));
